
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { NavbarUserMenu } from "@/components/Layout/NavbarUserMenu";
import { Search } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useState } from "react";
import { SearchCommandMenu } from "@/components/Search/SearchCommandMenu";

export function NavbarActions() {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  const [searchOpen, setSearchOpen] = useState(false);
  
  const handleSignInClick = () => {
    navigate('/auth');
  };
  
  const handleSignOutClick = async () => {
    try {
      await signOut();
      navigate('/');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };
  
  return (
    <div className="flex items-center space-x-2">
      <Button
        variant="ghost"
        size="icon"
        onClick={() => setSearchOpen(true)}
        className="text-muted-foreground md:hidden"
        aria-label="Search"
      >
        <Search className="h-4 w-4" />
      </Button>
      
      <NavbarUserMenu 
        handleSignInClick={handleSignInClick}
        handleSignOutClick={handleSignOutClick}
      />
      
      <SearchCommandMenu 
        open={searchOpen} 
        onOpenChange={setSearchOpen}
        onClose={() => setSearchOpen(false)}
      />
    </div>
  );
}
